import React, { FC } from 'react';
import { ReactComponent as LogoIcon } from '../../../../assets/images/Logo.svg';
import './MyBrizAppIcon.scss';

export const MyBrizAppIcon: FC = () => {
  return (
    <div className="my-briz-app">
      <LogoIcon />
    </div>
  );
};
